module.exports = __webpack_public_path__ + "assets/images/ending2_f4107843e5cdff25c843e96dcdf2df20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ending/ending2.png
// module id = 134
// module chunks = 0